<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 会议直播</div>
        <course v-if="courses.length > 0" :courses="courses" :watchedList="watchedList" isLiveStreaming="1" />
        <empty class="empty-margin" v-if="courses.length <= 0"></empty>
        <el-pagination class="paging" background :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="prev, pager, next, sizes" :total="totalCount" @size-change="sizeChange"
          @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
        </el-pagination>
      </div>
    </div>
    <!---->

    <footer-bar @showPrivacyPolicy="dialogFormVisible3 = true" @showUserAgreement="dialogFormVisible4 = true"></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import course from "@/components/base/course";
import { getInformationType, getLiveManagement } from '@/api/home'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, course, empty },
  data() {
    return {
      selectedIndex: 3,
      courses: [],
      watchedList: [], // 示例已观看的课程 ID
      navItems: [], // 导航项
      activeIndex: '', // 默认激活第一个项
      currentPage: 1,
      pageSize: 12,
      totalCount: 0,
      searchTitle: '',
    }
  },
  watch: {
    "$route" (to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.currentPage = 1
      this.getLiveManagement()
    },
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.getPageList()
    },
    // 列表查询资讯类型
    async getInformationType() {
      await getInformationType({
        categories: 'COURSE',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
      })
    },
    // 分页查询直播管理
    async getLiveManagement() {
      await getLiveManagement({
        number: this.currentPage,
        limit: this.pageSize,
        title: this.searchTitle,
      }).then(res => {
        this.courses = res.data
        this.totalCount = res.totalCount
      })
    },
    // 初始化
    async Initialization() {
      // await this.getInformationType()
      await this.getLiveManagement()
    },
    sizeChange(value) {
      this.pageSize = value
      this.currentPage = 1
      this.getPageList()
    },
    currentChange(value) {
      this.currentPage = value
      this.getPageList()
    },
    prevClick(value) {
      this.currentPage = value
      this.getPageList()
    },
    nextClick(value) {
      this.currentPage = value
      this.getPageList()
    },
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    wow.init();
    this.Initialization()
  }
}
</script>

<style lang="less" scoped>
/deep/.qualityControl-box .course-li {
  margin-top: 26px;
}

.center-box {
  padding-bottom: 80px;
}

/deep/.el-input__inner {
  // height: 32px;
  // border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  // color: rgba(0, 0, 0, 0.45) !important;
  // line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Meeting/index.vue